/**
 * v3 API - 系统相关接口
 *
 * 对应后端路由:
 *   /api/health      → api/routes/health.ts
 *   /api/system/info → api/routes/system.ts
 *
 * @module services/api/v3/system
 */

import request from './client.js';

// ============================================================================
// 健康检查
// ============================================================================

/**
 * 健康检查
 *
 * GET /api/health
 *
 * @returns {Promise<{ status: string, version: string, timestamp: string }>}
 */
export async function fetchHealth() {
  return request('/health');
}

// ============================================================================
// 系统信息
// ============================================================================

/**
 * 获取系统性能信息
 *
 * GET /api/system/info
 *
 * @returns {Promise<{
 *   cpu_percent: number,
 *   memory_percent: number,
 *   upload_rate_bps: number,
 *   download_rate_bps: number,
 *   timestamp: string
 * }>}
 */
export async function fetchSystemInfo() {
  return request('/system/info');
}
